import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { timestampDate } from '@bufbuild/protobuf/wkt'

import { Text } from '@enechain/ecloud-designsystem'

import { formatTimeOfDay } from '~/models/dateTime'

/** 取込がまだ 1 件も完了していない時のプレースホルダ (design `#bg-last-updated`)。 */
const PLACEHOLDER = '--:--:--'

type Props = {
  /** 「最終更新」/「託送実績データ 最終更新」など、画面ごとの見出し語。 */
  label: string
  /** backend が返す最終取込完了時刻。undefined = 未取込 (プレースホルダ表示)。 */
  lastUpdatedAt?: Timestamp
}

/**
 * 同時同量 需要画面の「託送実績データ 最終更新」表示 (doji-bg.md AC-BDB-002-1 /
 * AC-BDB-016)。ダッシュボードは page-header 右端、需要詳細はフィルタ直下の
 * メタ行に置く (design `balance/bg.html` の `#bg-last-updated` /
 * `balance/bg-region.html` の `#region-last-updated`)。
 *
 * 値は backend が解決した取込完了時刻 (託送 ingestion ledger の
 * MAX(processed_at)) をそのまま描くだけで、frontend では鮮度判定をしない。
 *
 * 未取込は 0 埋めせずプレースホルダに落とす — ゼロ値を時刻として描くと、
 * 一度も取り込んでいない日が「0:00 に更新済み」に見える。
 */
export const TakusoLastUpdated = ({
  label,
  lastUpdatedAt,
}: Props): React.ReactElement => (
  <Text as="span" textStyle="caption" color="Text.midEmphasis">
    {label}：
    <Text
      as="span"
      color="Text.highEmphasis"
      // design `.region-meta b { font-weight: 500 }` = 値だけラベルより一段強い。
      fontWeight="medium"
    >
      {lastUpdatedAt === undefined
        ? PLACEHOLDER
        : formatTimeOfDay(timestampDate(lastUpdatedAt))}
    </Text>
  </Text>
)
